<template>
	

	<!-- showChild="true" relative="false" external="true" selectedTheme="white-theme" :theme="selectedTheme"  -->
		<b-col cols="2" class="nevmobileRow" :class="[{'collapsed' : collapsed}]">
				
		<sidebar-menu :menu="menuNew"  :relative="false"  :show-one-child="true" @toggle-collapse="onToggleCollapse" @item-click="onItemClick">
			
		<div slot="header" class="profile">	
			<div class="btn-reset btnSticky" data-ember-action="" @click="clickHandler" :class="[{'rotateIcocollapsed' : collapsed}]"> </div>	
			<!-- <b-row class="m-0"  :class="[{'posmenu' : posmenu}]">
				<b-col cols="12" md="12" class="text-left" > 
					<b-link @click="clickHandler"><i class="fa fa-bars" aria-hidden="true"></i></b-link>				
				</b-col>
			</b-row> -->	
			<b-row class="m-0">
					<div class="profileP" :class="[{'posmenuProfile' : posmenuProfile}]">
					
					<!-- <b-img alt="" v-if="this.$session.get('customer_info').image=='' || this.$session.get('customer_info').image==null" :src="$root.MEDIAPATH+'blank.jpg'" class="img-circle navpp" :class="[{'navppnew' : navppnew}]"></b-img>  -->
					<b-link :href="$root.getDashboardLink()"><b-img   src="../assets/logo.png" class="img-circle navpp" alt="img" :class="[{'navppnew' : navppnew}]" ></b-img></b-link>
					</div>
				
				<!-- <b-col  cols="12" md="8" class="profile--namediv m-1">
					<span class="profile--name"> {{this.$session.get('customer_info').username}} </span>
				</b-col> -->				
			</b-row>
		</div>
		<!--<div slot="footer">footer</div>
		<span slot="toggle-icon">toggle-icon</span>
		<span slot="dropdown-icon">dropdown-icon</span> -->
		<span slot="toggle-icon"  ref="collepsmypanel"><i class="fa fa-arrows-h" aria-hidden="true"></i></span>
		</sidebar-menu>
      </b-col>      
                  
						
                    
               

</template>
<script>
/* const separator = {
  template: `<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">`
};*/
  /* import {
    mdbContainer,
   // mdbRow,
    //mdbIcon,
    mdbTreeview,
    mdbTreeviewItem
  } from "mdbvue"; */
   import { SidebarMenu } from 'vue-sidebar-menu'
  import '@/assets/nave.scss';
  export default {
    name: "TreeviewPage",
	props: {
		relative: {
		  type: Boolean,
		  default: true
		}
	
	},
    components: {
      //mdbContainer,
     // mdbRow,
      //mdbIcon,
     //mdbTreeview,
      //mdbTreeviewItem
	  SidebarMenu
    },
	data() {
		return{
				collapsed: false,
				posmenu: true,
				posmenuProfile: false,
				navppnew: false,
				themes: ['', 'white-theme'],
				selectedTheme: 'white-theme',
				menuNew: [
				   {
						header: true,
						/*title: 'Example' */
					},
					{
						href: this.$root.getDashboardLink(),
						title: 'Home',
						icon: 'fa fa-home',
						
				    },
					{
						href: '/control/',
						title: 'Control Manager',
						icon: 'fa fa-asterisk',					
					},
					{
						href: '/complaints/',
						title: 'Complaints Manager',
						icon: 'fa fa-comments',
					
					},					  
					{
						href: '',
						title: 'Reports',
						icon: 'fa fa-file-text',
						child: [
						  {
							href: '/device-report',
							title: 'Device Report',
							icon: 'fa fa-file-o'
						  },{
							href: '/consumption',
							title: 'Daily Consumption',
							icon: 'fa fa-file-o'
						  },
						  {
							href: '/monthlyconsumption',
							title: 'Monthly Consumption',
							icon: 'fa fa-file-o'
						  },

						]
						
					},
					{
						href: '',
						title: 'Settings',
						icon: 'fa fa-sliders',
						child: [
							{
							href: '/ulbs',
							title: 'Manage ULB',
							icon: 'fa fa-id-card-o'
							},
							{
							href: '/citys',
							title: 'Manage Cities',
							icon: 'fa fa-id-card-o'
							},{
							href: '/zones',
							title: 'Manage Zones',
							icon: 'fa fa-id-card-o'
							},
							,{
							href: '/wards',
							title: 'Manage Wards',
							icon: 'fa fa-id-card-o'
							},{
							href: '/users',
							title: 'Manage Users',
							icon: 'fa fa-users'
							},
							{
							href: '/device-group',
							title: 'Manage Group',
							icon: 'fa fa-object-group'
							},
							{
							href: '/replace-devices',
							title: 'Replace Device',
							icon: 'fa fa-retweet'
							},
						]
					}
					],
				menu: [
				   {
						header: true,
						/*title: 'Example' */
					  },
					  /*{
						title: 'Badge',
						icon: 'fa fa-cog',
						badge: {
						  text: 'new',
						  class: 'default-badge'
						}
					  },*/
					  {
						href: '',
						title: 'Dashboard',
						icon: 'fa fa-dashboard',
						child: [
						  {
							href: '/admin/dashboard/',
							title: 'Dashboard Admin',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/dashboard-seller/',
							title: 'Dashboard Sellers',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/dashboard-influencer/',
							title: 'Dashboard Influencer',
							icon: 'fa fa-file-alt'
						  },
						]
						
					  },
					  {
						href: '/admin/profile',
						title: 'Manage Profile',
						icon: 'fa fa-user',
						
					  },
					   {
						href: '',
						title: 'Manage Customers',
						icon: 'fa fa-users',
						child: [
						  {
							href: '/admin/customers/',
							title: 'Customer',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/sellers/',
							title: 'Sellers',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/agents/',
							title: 'Influencer',
							icon: 'fa fa-file-alt'
						  },
						  /* {
							href: '/admin/orders/',
							title: 'Orders',
							icon: 'fa fa-file-alt'
						  },*/						  
						 
						  
						]
					  },{
						href: '/admin/manageWallet',
						title: 'Manage Wallet',
						icon: 'fa fa-google-wallet',
					  },{
						href: '',
						title: 'Manage Products',
						icon: 'fa fa-product-hunt',
						child: [
						  {
							/*href: '/admin/products',*/
							href: '',
							title: 'Products',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/product-requests',
							title: 'Products Request',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/product-approved',
							title: 'Products Approved',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/product-rejected',
							title: 'Products Rejected',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/product/category',
							title: 'Category',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/top-recommendation',
							title: 'Recommendation',
							icon: 'fa fa-file-alt'
						  },
						  
						]
					  },					  
					  {
						href: '/admin/product-brand',
						title: 'Manage Brands',
						icon: 'fa fa-picture-o',
						
					  },/*{
						href: '/admin/manageOffers',
						title: 'Manage Offers',
						icon: 'fa fa-picture-o',
						
					  },*/
					  {
						
						title: 'Manage Registration',
						icon: 'fa fa-industry',	
						child: [
						  {
							title: 'Seller',
							child: [
							  {
								href: '/admin/marketing-data',
								title: 'New',
							  },{
								href: '/admin/marketing-data-active-seller',
								title: 'Approved',
							  },{
								href: '/admin/marketing-data-active-seller-listed',
								title: 'Listed',
							  },{
								href: '/admin/marketing-data-deactive-seller',
								title: 'Deactivated',
							  },{
								href: '/admin/marketing-data-active-s-unlogged',
								title: 'Un-logged',
							  }
							  ]
						  },{
							title: 'Influencer',
							child: [
							  {
								href: '/admin/marketing-data-sales-advisor',
								title: 'New',
							  },{
								href: '/admin/marketing-data-active-sales-advisor',
								title: 'Approved',
							  },{
								href: '/admin/marketing-data-active-sa-unlogged',
								title: 'Un-logged',
							  }
							  ]
						  },{
							title: 'Customers',
							child: [
							  {
								href: '/admin/marketing-data-customers',
								title: 'New',
							  },{
								href: '/admin/marketing-data-active-customers',
								title: 'Approved',
							  }/*,{
								href: '/admin/marketing-data-active-sa-unlogged',
								title: 'Un-logged',
							  }*/
							  ]
						  },
						  
						]
					  },{
						href: '',
						title: 'Settings',
						icon: 'fa fa-cog',
						child: [
						  {
							href: '/admin/colors',
							title: 'Manage Colors',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/users',
							title: 'Users',
							icon: 'fa fa-file-alt'
						  },
						  
						]
					  },
					  {
						href: '',
						title: 'Manage Orders',
						icon: 'fa fa-first-order',
						child: [
						  {
							href: '/admin/orders',
							title: 'Orders',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/cancelled-orders',
							title: 'Cancelled Orders',
							icon: 'fa fa-file-alt'
						  },{
							href: '/admin/returned-orders',
							title: 'Returned Orders',
							icon: 'fa fa-file-alt'
						  }
						]
					  },
					  {
						href: '/admin/coupons',
						title: 'Manage Coupons',
						icon: 'fa fa-wpforms',
						
					  }
					  ,{
						href: '',
						title: 'Reports',
						icon: 'fa fa-bar-chart',
						child: [
							{
							href: '/admin/salespromotion',
							title: 'Comm Report',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '',
							title: 'Order Report',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '',
							title: 'Activity Report',
							icon: 'fa fa-file-alt'
						  }
						  
						]
					  },
					  {
						href: '',
						title: 'Manage Template',
						icon: 'fa fa-file',
						child: [
							{
							href: '/admin/template-list',
							title: 'Email Template',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/admin/template-category-list',
							title: 'Template Category',
							icon: 'fa fa-file-alt'
						  }
						  
						]
					  },{
						href: '',
						title: 'Careers',
						icon: 'fa fa-graduation-cap',
						child: [
							{
							href: '/admin/career-post',
							title: 'Jobs List',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '/admin/career-apply-list',
							title: 'Apply List',
							icon: 'fa fa-file-alt'
						  }
						  
						]
					  },{
						href: '/admin/survey-list',
						title: 'Survey',
						icon: 'fa fa-wpforms',
						
					  },{
						href: '/admin/surveyseller-list',
						title: 'Survey seller',
						icon: 'fa fa-wpforms',
						
					  },{
						href: '/admin/contactus-list',
						title: 'Contact Us',
						icon: 'fa fa-phone',
						
					  },
					 
							 /* {
								title: 'Multiple Level',
								icon: 'fa fa-list-alt',
								child: [
								  {
									title: 'page'
								  },
								  {
									title: 'Level 2 ',
									child: [
									  {
										title: 'page'
									  },
									  {
										title: 'Page'
									  }
									]
								  },
								  {
									title: 'Page'
								  },
								  {
									title: 'Another Level 2',
									child: [
									  {
										title: 'Level 3',
										child: [
										  {
											title: 'Page'
										  },
										  {
											title: 'Page'
										  }
										]
									  }
									]
								  }
								]
							},
							{
						href: '#disabled',
						title: 'Disabled page',
						icon: 'fa fa-lock',
						disabled: true
					  },
						  {
						header: true,
						component: separator,
						visibleOnCollapse: true
					  },
						{
						header: true,
						title: 'Another Example'
					  },
					  {
						href: '#disabled',
						title: 'Disabled page',
						icon: 'fa fa-lock',
						disabled: true
					  },
					  {
						title: 'Badge',
						icon: 'fa fa-cog',
						badge: {
						  text: 'new',
						  class: 'default-badge'
						}
					  },
					  {
						href: '#page',
						title: 'Dropdown Page',
						icon: 'fa fa-list-ul',
						child: [
						  {
							href: '#sub-page-1',
							title: 'Sub Page 01',
							icon: 'fa fa-file-alt'
						  },
						  {
							href: '#sub-page-2',
							title: 'Sub Page 02',
							icon: 'fa fa-file-alt'
						  }
						]
					  },
					  {
						title: 'Multiple Level',
						icon: 'fa fa-list-alt',
						child: [
						  {
							title: 'page'
						  },
						  {
							title: 'Level 2 ',
							child: [
							  {
								title: 'page'
							  },
							  {
								title: 'Page'
							  }
							]
						  },
						  {
							title: 'Page'
						  },
						  {
							title: 'Another Level 2',
							child: [
							  {
								title: 'Level 3',
								child: [
								  {
									title: 'Page'
								  },
								  {
									title: 'Page'
								  }
								]
							  }
							]
						  }
						]
					} */
		]

		};
	},
	methods: {
		onToggleCollapse(collapsed) {
			//console.log('Ram Ram'+collapsed);
			 this.collapsed = collapsed;
			 this.posmenuProfile = collapsed;
			 this.navppnew = collapsed;
			 if(!collapsed){
				this.posmenu = true;
			 }else{
				this.posmenu = false;
			 }
		},
		onItemClick(event, item, node) {
		console.log(event+','+item+','+node);
		}, 	
		clickHandler() {
			this.$refs.collepsmypanel.click();
		}	

	}
	
  };
</script>
<style  lang="scss">



</style>